import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux'

import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx';
import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js';
import conf from '../../../../shared/conf.js';
import Input from '../../Form/Field/Input.jsx';
import Select from '../../Form/Field/Select.jsx';
import Loader from '../../../../shared/components/Loader/Loader.jsx';
import validate from './validate';

export const name = 'UserForm';

class UserForm extends Component {
  static propTypes = {
    className: PropTypes.string,
  };

  static defaultProps = {
    className: '',
  };

  render() {
    return (
      <div id={name} className={this.props.className}>
        <form autoComplete="off" onSubmit={this.props.handleSubmit}>
          <div className="row">
            <div className="col-md-6">
              <Field
                label="Prénom"
                name="firstname"
                placeholder="John..."
                type="text"
                component={Input}/>
            </div>
            <div className="col-md-6">
              <Field
                label="Nom"
                name="lastname"
                placeholder="Doe..."
                type="text"
                component={Input}/>
            </div>
            <div className="col-md-6">
              <Field
                label="Email"
                name="email"
                component={Input}
                type="text"
                placeholder="john@doe.fr"/>
            </div>
            <div className="col-md-6">
              <Field
                label="Type de compte"
                name="account_type"
                type="select"
                component={Select}
              >
                {Object.keys(conf.accountTypes).map((key) => {
                  const value = conf.accountTypes[key];
                  return (
                    <option value={value} key={value}>{key}</option>
                  );
                })}
              </Field>
            </div>
            <div className="col-md-6">
              <Field
                label="Univers"
                name="main_universe"
                type="select"
                component={Select}
              >
                {this.props.universes
                  .filter(universe => this.props.currentUser.universes.includes(universe.id))
                  .map((universe) => (
                    <option value={universe.id} key={universe.id}>{universe.name}</option>
                  ))}
              </Field>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <Field
                label="Mot de passe*"
                name="plain_password"
                placeholder="Mot de passe"
                component={Input}
                type="password"/>
            </div>
            <div className="col-md-6">
              <Field
                label="Numéro de téléphone"
                name="tel"
                placeholder="Votre numéro"
                component={Input}
                type="text"/>
            </div>
          </div>
          <input className="d-none" type="submit"/>
          <FormGlobalErrors className="mt-0" errors={this.props.error}/>
        </form>
        <Loader visible={this.props.submitting || this.props.triggerSubmit}/>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    universes: state.universe.universes,
    currentUser: state.currentUser.user
  })
)(reduxForm({
  form: name,
  onSubmitFail: createOnSubmitFailHandler(name),
  validate
})(UserForm));